import React, { Component } from "react";
import { connect } from "react-redux";
import { getSESProductQtyChanges } from "../../actions";
import { Container, Row, Col, Button, Form, Table, Badge, Spinner, InputGroup } from "react-bootstrap";
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import ViewModal from "./ViewModal";
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';

class SESProductQtyChangeList extends Component {
  state = {
    loading: false,
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: 'created_at',
    sortOrder: -1,
    keyword: '',
    showModal: false,
    selectedQtyChange: null,
    mode: 'view'
  };

  componentDidMount() {
    this.loadQtyChanges();
  }

  loadQtyChanges = () => {
    this.setState({ loading: true });
    this.props.getSESProductQtyChanges({
      currentPage: this.state.currentPage,
      itemsPerPage: this.state.itemsPerPage,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,
      keyword: this.state.keyword
    })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.loadQtyChanges);
  };

  handleSort = (field) => {
    this.setState(prevState => ({
      sortBy: field,
      sortOrder: prevState.sortBy === field ? -prevState.sortOrder : -1
    }), this.loadQtyChanges);
  };

  handleSearch = (e) => {
    this.setState({ keyword: e.target.value, currentPage: 1 }, this.loadQtyChanges);
  };

  handleView = (qtyChange) => {
    this.setState({
      showModal: true,
      selectedQtyChange: qtyChange,
      mode: 'view'
    });
  };

  handleEdit = (qtyChange) => {
    this.setState({
      showModal: true,
      selectedQtyChange: qtyChange,
      mode: 'edit'
    });
  };

  handleCreate = () => {
    this.setState({
      showModal: true,
      selectedQtyChange: null,
      mode: 'edit'
    });
  };

  getTypeBadge = (type) => {
    const typeColors = {
      'IMPORT': 'success',
      'EXPORT': 'danger',
      'ADJUSTMENT': 'warning',
      'RETURN': 'info',
      'DAMAGED': 'dark',
      'LOST': 'secondary',
      'INVENTORY_CHECK': 'primary',
      'OTHER': 'light'
    };
    const langKey = LANGUAGE_KEYS['TEXT_' + type];
    const label = langKey ? getTranslate(langKey) : type;
    return <Badge bg={typeColors[type] || 'light'}>{label}</Badge>;
  };

  render() {
    const { qtyChanges, totalCount } = this.props;
    const { loading, currentPage, itemsPerPage, sortBy, sortOrder, keyword, showModal, selectedQtyChange, mode } = this.state;
    const totalPages = Math.ceil(totalCount / itemsPerPage);

    console.log("qtyChanges", qtyChanges);

    return (
      <Container fluid>
        <h2 className="text-center">{getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY_CHANGE_HISTORY)}</h2>
        
        <Row className="mb-3">
          <Col md={6}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SEARCH_BY_PRODUCT_CODE) || "Search by product code..."}
                value={keyword}
                onChange={this.handleSearch}
              />
            </InputGroup>
          </Col>
          <Col md={6} className="text-end">
            <Button variant="primary" onClick={this.handleCreate}>
              <FaPlus /> {getTranslate(LANGUAGE_KEYS.TEXT_ADD_NEW_CHANGE)}
            </Button>
          </Col>
        </Row>

        {loading && (
          <div className="text-center mb-3">
            <Spinner animation="border" variant="primary" />
            <span className="ms-2">Loading changes...</span>
          </div>
        )}

        <Table striped bordered hover responsive>
          <thead> 
            <tr>
              <th onClick={() => this.handleSort('product_code')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_CODE)} {sortBy === 'product_code' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('warehouse_id')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_WAREHOUSE_ID)} {sortBy === 'warehouse_id' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('quantity')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_QUANTITY)} {sortBy === 'quantity' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('quantity_change')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_CHANGE_AMOUNT)} {sortBy === 'quantity_change' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_QUANTITY)}</th>
              <th onClick={() => this.handleSort('type')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_TYPE)} {sortBy === 'type' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_REFERENCE_ID)}</th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_STAFF_NOTE)}</th>
              <th onClick={() => this.handleSort('updated_by')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_BY)} {sortBy === 'updated_by' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('created_at')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_DATE)} {sortBy === 'created_at' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_ACTIONS)}</th>
            </tr>
          </thead>
          <tbody>
            {qtyChanges.map((change) => (
              <tr key={change._id}>
                <td>{change.product_code}</td>
                <td>{change.warehouse_id}</td>
                <td>{change.quantity}</td>
                <td className={change.quantity_change >= 0 ? 'text-success' : 'text-danger'}>
                  {change.quantity_change >= 0 ? '+' : ''}{change.quantity_change}
                </td>
                <td>{change.quantity + change.quantity_change}</td>
                <td>{this.getTypeBadge(change.type)}</td>
                <td>{change.reference_id}</td>
                <td>{change.staff_note}</td>
                <td>{change.updated_by}</td>
                <td>{new Date(change.created_at).toLocaleString()}</td>
                <td>
                  <Button 
                    variant="info" 
                    size="sm" 
                    className="me-2"
                    onClick={() => this.handleView(change)}
                    title={getTranslate(LANGUAGE_KEYS.TEXT_VIEW)}
                  >
                    <i className="fas fa-eye"></i> {getTranslate(LANGUAGE_KEYS.TEXT_VIEW)}
                  </Button>
                  <Button 
                    variant="primary" 
                    size="sm" 
                    className="me-2"
                    onClick={() => this.handleEdit(change)}
                    title="Edit"
                  >
                    <FaEdit /> Edit
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <Button
              variant="outline-primary"
              className="me-2"
              disabled={currentPage === 1}
              onClick={() => this.handlePageChange(currentPage - 1)}
            >
              {getTranslate(LANGUAGE_KEYS.TEXT_PREVIOUS_PAGE)}
            </Button>
            <span className="mx-2 my-auto">
              {getTranslate(LANGUAGE_KEYS.TEXT_PAGE)} {currentPage} / {totalPages}
            </span>
            <Button
              variant="outline-primary"
              className="ms-2"
              disabled={currentPage === totalPages}
              onClick={() => this.handlePageChange(currentPage + 1)}
            >
              {getTranslate(LANGUAGE_KEYS.TEXT_NEXT_PAGE)}
            </Button>
          </div>
        )}

        <ViewModal 
          show={showModal} 
          onClose={() => this.setState({ showModal: false, selectedQtyChange: null })} 
          currentQtyChange={selectedQtyChange}
          mode={mode}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  qtyChanges: state.sesProductQtyChangeReducer.qtyChanges,
  totalCount: state.sesProductQtyChangeReducer.totalCount
});

export default connect(mapStateToProps, {
  getSESProductQtyChanges
})(SESProductQtyChangeList); 